import ReactDOM from 'react-dom';
import React from 'react';

import home from './home/home.jsx';

ReactDOM.render(React.createElement(home, {}, null), document.getElementById('home'));